<template>
  <InfoModalTrigger title="Automatic parcel pickup">
    <p class="mb-2"><strong>If enabled</strong></p>
    <p class="mb-2">
      Within assignment with distribution channel Parcel after labels are created pickup is automatically booked within
      selected carrier.
    </p>
    <p class="mb-3">
      If assignment is created from PacSort console, customer can select pickup time within the upcoming week with
      default to next business day.
    </p>
    <p class="mb-3">If assignment is created from Public API or Integration pickup is automatically booked for the next day.</p>
    <p class="mb-3">
      This works for both explicitly picking Parcel distribution channel when creating the assignment and when original
      distribution channel was Parcel and then fallback by overweight rule happened.
    </p>
    <p class="mb-2"><strong>If disabled</strong></p>
    <p class="mb-0">
      Pickup is not booked in neither of the cases. When creating the assignment from PacSort the pickup date calendar
      is not displayed.
    </p>
  </InfoModalTrigger>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InfoModalTrigger from '@/views/Components/Elements/InfoModalTrigger.vue'

export default defineComponent({
  name: 'AutoPickupInfoModal',
  components: { InfoModalTrigger },
})
</script>
